import { useRef, useState, useCallback } from "react";
import { Box, Button } from "@mui/material";
import Webcam from "react-webcam";
import Modal from ".";

// Request as high a resolution as possible from the webcam.
const videoConstraints = {
  facingMode: "environment",
  width: { ideal: 2160 },  // Ask for very high camera res, browsers will clip to hardware.
  height: { ideal: 2160 },
};

export default function CameraCaptureModal({
  open,
  onClose,
  image, // controlled value
  onChange, // controlled setter
  width = "360px",
  title = "Capture Label"
}) {
  const webcamRef = useRef(null);
  const [imageSrc, setImageSrc] = useState(image);

  // Capture the photo by drawing the actual video element onto a canvas at its natural size.
  const capture = useCallback(() => {
    if (
      webcamRef.current &&
      webcamRef.current.video &&
      webcamRef.current.video.videoWidth > 0 &&
      webcamRef.current.video.videoHeight > 0
    ) {
      const video = webcamRef.current.video;
      // Use the video element's actual resolution
      const canvas = document.createElement("canvas");
      canvas.width = video.videoWidth;
      canvas.height = video.videoHeight;
      const ctx = canvas.getContext("2d");
      ctx.drawImage(video, 0, 0, canvas.width, canvas.height);
      const dataUrl = canvas.toDataURL("image/jpeg");
      setImageSrc(dataUrl);
    } else {
      // fallback in case video is not yet ready
      const fallback = webcamRef.current?.getScreenshot?.();
      setImageSrc(fallback);
    }
  }, [webcamRef]);

  const usePhoto = () => {
    onChange(imageSrc);
    onClose(); // close modal
  };

  const retake = () => {
    setImageSrc(null);
  };

  return (
    <Modal width={width} title={title} open={open} onClose={onClose}>
      <Box sx={{ display: "flex", flexDirection: "column", gap: 2 }}>
        {!imageSrc ? (
          <>
            <Webcam
              ref={webcamRef}
              audio={false}
              screenshotFormat="image/jpeg"
              videoConstraints={videoConstraints}
              style={{
                width: "100%",
                borderRadius: 8,
              }}
              mirrored={false}
              screenshotQuality={1}
            />
            <Button variant="contained" onClick={capture}>
              Capture
            </Button>
          </>
        ) : (
          <>
            <img
              src={imageSrc}
              style={{ width: "100%", maxHeight: "400px", borderRadius: 8 }}
              alt="captured"
            />

            <Button variant="outlined" onClick={retake}>
              Retake
            </Button>

            <Button variant="contained" onClick={usePhoto}>
              Use Photo
            </Button>
          </>
        )}
      </Box>
    </Modal>
  );
}
